import * as Sentry from "@sentry/react";

// Sentry-SDK инициализация для браузерного фронта Baton (#617).
//
// Порт backend-паттерна `backend/baton/core/infra/observability.py`
// (#613/#614) на browser-SDK: тот же GlitchTip (Sentry-совместим),
// та же скип-логика «пусто DSN → init не зовётся» (dev/тесты не
// таскают sentry-pipe), тот же низкий tracesSampleRate.
//
// Отличия браузерного SDK (`@sentry/react` v10):
//   - DSN публичен по дизайну (вшит в JS-бандл) — это нормально, см.
//     issue про inbound-фильтры на стороне GlitchTip для прода.
//   - Опция `autoSessionTracking` удалена в v8+. Sessions API GlitchTip
//     не поддерживает, поэтому дефолтную интеграцию `BrowserSession`
//     отфильтровываем явно, чтобы не слать unsupported-payload.

// Имя дефолтной интеграции отслеживания сессий — GlitchTip её не
// поддерживает, отфильтровываем из набора интеграций по умолчанию.
const BROWSER_SESSION_INTEGRATION = "BrowserSession";

export interface SentryConfig {
  // GlitchTip / Sentry DSN или `undefined` (тогда no-op).
  readonly dsn: string | undefined;
  // Tag окружения (`prod` / `staging` / `dev`) для фильтрации в GlitchTip.
  readonly environment: string;
  // Версия билда (commit SHA) или `undefined` — GlitchTip отделяет
  // версии по release.
  readonly release: string | undefined;
}

// Доля транзакций для performance monitoring. Низкая (1%), чтобы
// disk-space в GlitchTip не рос быстро — как на backend-стороне.
const TRACES_SAMPLE_RATE = 0.01;

export function initSentry(config: SentryConfig): boolean {
  // Инициализировать `@sentry/react`, только если задан DSN. Возвращает
  // `true` если init прошёл, `false` если skip (нет DSN — dev/тесты).
  if (!config.dsn) {
    return false;
  }
  Sentry.init({
    dsn: config.dsn,
    environment: config.environment,
    release: config.release,
    tracesSampleRate: TRACES_SAMPLE_RATE,
    integrations: (defaults) =>
      defaults.filter(
        (integration) => integration.name !== BROWSER_SESSION_INTEGRATION,
      ),
  });
  return true;
}
